import { CheckStatus, Parse } from '../utils/ajax';

const paramsToQueryString = params => Object.keys(params).reduce((str, paramName) => {
    let reassignedParamName = paramName;

    // When making a request to the states grouping endpoint
    // multiple flow id's are sent as url parameters, but they all
    // use the same parameter name - flow. So when we send the object
    // containing params to be converted to a query string it contains
    // keys like "flow-1, flow-2" etc. So we need to strip out the hyphen and integer

    // TODO: this is a temporary workaround for a hotfix, the parameters could be passed
    /**
     *  [
            { key: 'flow', value: 'aaa' },
            { key: 'flow', value: 'bbb' },
            { key: 'xyz', value: '123' },
        ]
        */
    if (paramName.indexOf('flow') >= 0) {
        reassignedParamName = paramName.substr(0, paramName.indexOf('-'));
    }
    return `${str === '' ? '?' : `${str}&`}${encodeURIComponent(reassignedParamName)}=${encodeURIComponent(params[paramName])}` 
}, '');

export const getFlows = ({ token, tenantId, params = {} }) => {

    const queryString = paramsToQueryString(params);

    const url = `/api/admin/1/states/flow${queryString}`;

    const request = {
        headers: {
            Authorization: token,
            ManyWhoTenant: tenantId,
        },
    };

    return fetch(url, request)
        .then(CheckStatus)
        .then(Parse); 
};

export const getStatesByFlow = ({ token, tenantId, flowId, params = {} }) => {

    const queryString = paramsToQueryString(params);

    const url = `/api/admin/1/states/flow/${flowId}${queryString}`;

    const request = {
        headers: {
            Authorization: token,
            ManyWhoTenant: tenantId,
        },
    };

    return fetch(url, request)
        .then(CheckStatus)
        .then(Parse);
};

export const getLaunchesByFlow = ({ token, tenantId, flowId, params = {} }) => {
    const queryString = paramsToQueryString(params);
    const url = `/api/dashboard/1/flow/${flowId}${queryString}`;
    const request = {
        headers: {
            Authorization: token,
            ManyWhoTenant: tenantId,
        },
    };

    return fetch(url, request)
        .then(CheckStatus)
        .then(Parse);
};

export const getGroupedFlowStates = ({ token, tenantId, timeUnit, params = {} }) => {
    const queryString = paramsToQueryString(params);
    
    const url = `/api/metrics/1/states/created/flow/${timeUnit}${queryString}`;

    const request = {
        headers: {
            Authorization: token,
            ManyWhoTenant: tenantId,
        },
    };

    return fetch(url, request)
        .then(CheckStatus)
        .then(Parse); 
};
